<template>
  <div id="position">
    <div class="hr_container">
      <div class="hr_index">
        <div class="hr_img">
          <img src="../../../assets/hr/banner.png" alt="" />
        </div>
      </div>
      <van-tabs v-model="active" @change="tabChange">
        <van-tab title="未发布">
          <div class="tab_list">
            <div class="select_all" v-if="unpublishedList.length > 0">
              <van-checkbox
                v-model="unpubChecked"
                checked-color="#4EA27C"
                @click="unpubCheckboxClickAll"
                >全选</van-checkbox
              >
            </div>
            <div class="unpublished_list">
              <div
                class="unpublished_item unpublished_item1"
                v-for="(item, index) in unpublishedList"
                :key="index"
              >
                <div class="model" @click="jumpPageDetail(item)"></div>
                <div class="item_top">
                  <div class="item_top_title">
                    <div class="title">{{ item.position_name }}</div>
                    <div class="type" v-if="item.type1">转交</div>
                    <div class="type" v-if="item.type2">共享</div>
                  </div>
                  <div class="item_top_check">
                    <van-checkbox
                      v-model="item.unpubChecked"
                      checked-color="#4EA27C"
                      @click="unpubCheckboxClickItem(item)"
                    ></van-checkbox>
                  </div>
                </div>
                <div class="item_content">
                  <div>{{ item.work_experience }}</div>
                  <div class="partition">|</div>
                  <div>{{ item.education }}</div>
                  <div class="partition">|</div>
                  <div>{{ item.work_addr }}</div>
                </div>
                <div class="item_btm">
                  <div class="item_btm_info">{{ item.orgName }}</div>
                  <div class="item_btm_time">
                    要求到岗时间：{{ item.duty_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="已发布">
          <div class="tab_list">
            <div class="select_all" v-if="publishedList.length > 0">
              <van-checkbox
                v-model="pubChecked"
                checked-color="#4EA27C"
                @click="pubCheckboxClickAll"
                >全选</van-checkbox
              >
            </div>
            <div class="unpublished_list">
              <div
                class="unpublished_item"
                v-for="(item, index) in publishedList"
                :key="index"
              >
                <div class="model" @click="jumpPageDetail(item)"></div>
                <div class="item_top">
                  <div class="item_top_title">
                    <div class="title">{{ item.position_name }}</div>
                    <div class="urgent" v-if="item.urgency_state == 1">
                      {{ item.urgency_state == 1 ? "急招" : "" }}
                    </div>
                    <div class="type" v-if="item.type1">转交</div>
                    <div class="type" v-if="item.type2">共享</div>
                  </div>
                  <div class="item_top_check">
                    <van-checkbox
                      v-model="item.pubChecked"
                      checked-color="#4EA27C"
                      @click="pubCheckboxClickItem(item)"
                    ></van-checkbox>
                  </div>
                </div>
                <div class="item_content">
                  <div>{{ item.work_experience }}</div>
                  <div class="partition">|</div>
                  <div>{{ item.education }}</div>
                  <div class="partition">|</div>
                  <div>{{ item.work_addr }}</div>
                </div>
                <div class="item_tag_container">
                  <div
                    class="item_tag"
                    v-for="i in item.job_type.split('|')"
                    :key="i"
                  >
                    {{ i }}
                  </div>
                </div>
                <div class="item_btm">
                  <div class="item_btm_info">{{ item.orgName }}</div>
                  <div class="item_btm_time off_time">
                    推荐奖金：{{ item.bonus || 0 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="已下架">
          <div class="tab_list">
            <div class="select_all" v-if="takeOffList.length > 0">
              <van-checkbox
                v-model="offChecked"
                checked-color="#4EA27C"
                @click="offCheckboxClickAll"
                >全选</van-checkbox
              >
            </div>
            <div class="unpublished_list">
              <div
                class="unpublished_item"
                v-for="(item, index) in takeOffList"
                :key="index"
              >
                <div class="model" @click="jumpPageDetail(item)"></div>
                <div class="item_top">
                  <div class="item_top_title">
                    <div class="title">{{ item.position_name }}</div>
                    <div class="urgent" v-if="item.urgency_state == 1">
                      {{ item.urgency_state == 1 ? "急招" : "" }}
                    </div>
                    <div class="type" v-if="item.type1">转交</div>
                    <div class="type" v-if="item.type2">共享</div>
                  </div>
                  <div class="item_top_check">
                    <van-checkbox
                      v-model="item.offChecked"
                      checked-color="#4EA27C"
                      @click="offCheckboxClickItem(item)"
                    ></van-checkbox>
                  </div>
                </div>
                <div class="item_content">
                  <div>{{ item.work_experience }}</div>
                  <div class="partition">|</div>
                  <div>{{ item.education }}</div>
                  <div class="partition">|</div>
                  <div>{{ item.work_addr }}</div>
                </div>
                <div class="item_tag_container">
                  <div
                    class="item_tag"
                    v-for="i in item.job_type.split('|')"
                    :key="i"
                  >
                    {{ i }}
                  </div>
                </div>
                <div class="item_btm">
                  <div class="item_btm_info">{{ item.orgName }}</div>
                  <div class="item_btm_time off_time">
                    推荐奖金：{{ item.bonus || 0 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="btn_container">
        <el-button
          v-if="active === 0 || active === 1"
          type="primary"
          @click="batchShelf"
          >批量下架</el-button
        >
        <el-button type="primary" @click="batchOperation">批量操作</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/inside";
import { getToken } from "@/utils/cookie";
export default {
  name: "position",
  data() {
    return {
      salaryInfo: {},
      active: 0,
      unpubChecked: false,
      unpublishedList: [],
      pubChecked: false,
      publishedList: [],
      offChecked: false,
      takeOffList: [],
      itemListData: [],
      total: 0,
      empNo: "",
    };
  },
  created() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
  },
  mounted() {
    this.empNo = getToken()
    if (sessionStorage.getItem("active")) {
      this.active = Number(sessionStorage.getItem("active"));
      this.PostManagement(Number(this.active));
    } else {
      this.active = 0;
      this.PostManagement(0);
    }
  },
  methods: {
    //获取岗位列表
    PostManagement(state) {
      api
        .PostManagement({
          state, //0：未发布，1：已发布，2：已下架，不填则默认为0
          empNo: this.salaryInfo.empNo,
        })
        .then((res) => {
          res.data.map((item) => {
            item.unpubChecked = false;
            item.pubChecked = false;
            item.offChecked = false;
          });

          if (state == 0) {
            this.unpublishedList = res.data;
          } else if (state == 1) {
            this.publishedList = res.data;
          } else if (state == 2) {
            this.takeOffList = res.data;
          }
        });
    },
    //tab切换
    tabChange(val) {
      sessionStorage.setItem("active", val);
      this.total = 0;
      this.PostManagement(val);
    },
    // 0：未发布
    unpubCheckboxClickAll() {
      if (this.unpubChecked) {
        this.total = this.unpublishedList.length;
        this.unpublishedList.map((item) => {
          item.unpubChecked = true;
        });
      } else {
        this.total = 0;
        this.unpublishedList.map((item) => {
          item.unpubChecked = false;
        });
      }
    },
    //单选
    unpubCheckboxClickItem(itemList) {
      if (itemList.unpubChecked) {
        this.itemListData.push(itemList);
      }
      this.itemListData.map((obj, index) => {
        if (!obj.unpubChecked) {
          this.itemListData.splice(index, 1);
        }
      });
      this.unpublishedList.map((item) => {
        if (item.unpubChecked) {
          this.total++;
        }
      });
    },
    // 1：已发布
    pubCheckboxClickAll() {
      if (this.pubChecked) {
        this.publishedList.map((item) => {
          item.pubChecked = true;
        });
      } else {
        this.publishedList.map((item) => {
          item.pubChecked = false;
        });
      }
    },
    //单选 已发布
    pubCheckboxClickItem(itemList) {
      if (itemList.pubChecked) {
        this.itemListData.push(itemList);
      }
      this.itemListData.map((obj, index) => {
        if (!obj.pubChecked) {
          this.itemListData.splice(index, 1);
        }
      });
      this.publishedList.map((item) => {
        if (item.pubChecked) {
          this.total++;
        }
      });
    },
    // 2：已下架
    offCheckboxClickAll() {
      if (this.offChecked) {
        this.takeOffList.map((item) => {
          item.offChecked = true;
        });
      } else {
        this.takeOffList.map((item) => {
          item.offChecked = false;
        });
      }
    },
    //单选 2：已下架
    offCheckboxClickItem(itemList) {
      if (itemList.offChecked) {
        this.itemListData.push(itemList);
      }
      this.itemListData.map((obj, index) => {
        if (!obj.offChecked) {
          this.itemListData.splice(index, 1);
        }
      });
      this.takeOffList.map((item) => {
        if (item.offChecked) {
          this.total++;
        }
      });
    },
    //跳转详情
    jumpPageDetail(item) {
      this.$router.push({
        path: "/HR/jobDetails",
        query: {
          item: JSON.stringify(item),
        },
      });
    },
    // 批量下架
    batchShelf() {
      let idList = [],
        nameList = [];
      this.itemListData.map((obj) => {
        idList.push(obj.id);
        nameList.push(obj.position_name);
      });
      if (this.total > 0) {
        api
          .PostBatchRevise1({
            id: idList.join(','),
            bonus: '', // 内推分红奖励,（必填，可为空）
            pay_range: '', // 薪资范围：中间用“-”,（必填，可为空）隔开
            job_type: '', // 招聘类型
            urgency_state: '', // 紧急标签是否显示，0：不显示，1：显示（必填，可为空）
            state: this.active, //岗位状态信息：0：未发布，1：已发布，2：已下架
          })
          .then((res) => {
            if (res.code == 200) {
              this.PostManagement(Number(this.active));
            }
          });
      } else {
        this.$message({
          message: "请至少选中一个",
          type: "warning",
        });
      }
    },
    // 批量操作
    batchOperation() {
      let idList = [],
        nameList = [];
      this.itemListData.map((obj) => {
        idList.push(obj.id);
        nameList.push(obj.position_name);
      });
      if (this.total > 0) {
        this.$router.push({
          path: "/HR/batchOperation",
          query: {
            idList,
            nameList,
            active: this.active,
            batchFlag: true,
          },
        });
      } else {
        this.$message({
          message: "请至少选中一个",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #position {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #position {
    width: 276px * $zoom;
  }
}
#position {
  font-size: 16px * $zoom;
  position: relative;
  .hr_container {
    width: 100%;
    min-height: 100vh;
    background: #f7f9fa;
    .hr_index {
      width: 100%;
      padding: 50px 32px;
      background: linear-gradient(
        180deg,
        #5cc385 0%,
        rgba(104, 224, 174, 0) 100%
      );
      .hr_img {
        width: 100%;
        height: 260px;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .tab_list {
      padding: 0 32px;
      .select_all {
        overflow: hidden;
        .van-checkbox {
          float: right;
        }
        ::v-deep .van-checkbox__label {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #666666;
        }
      }
      .unpublished_list {
        height: calc(100vh - 600px) ;
        margin-top: 10px;
        overflow-y: auto;
        /* 隐藏滚动条 */
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .unpublished_item {
          position: relative;
          width: 100%;
          // height: 210px;
          margin-bottom: 24px;
          padding: 30px;
          background: #fff;
          border-radius: 16px;
          .model {
            position: absolute;
            left: 0;
            top: 0;
            width: 80%;
            height: 100%;
            cursor: pointer;
          }
          .item_top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .item_top_title {
              display: flex;
              font-size: 32px;
              font-weight: bold;
              color: #282b32;
              line-height: 40px;
              .urgent {
                width: 72px;
                height: 40px;
                line-height: 40px;
                border-radius: 6px;
                border: 2px solid #e22121;
                margin-left: 12px;
                text-align: center;
                font-size: 24px;
                font-weight: 400;
                color: #e22121;
              }
              .type {
                width: 72px;
                height: 40px;
                line-height: 40px;
                border-radius: 6px;
                border: 2px solid rgb(116, 113, 113);
                margin-left: 12px;
                text-align: center;
                font-size: 24px;
                font-weight: 400;
                color: rgb(116, 113, 113);
              }
            }
            .item_top_check {
              position: relative;
              z-index: 999;
            }
          }
          .item_content {
            display: flex;
            margin-top: 16px;
            font-size: 28px;
            color: #666666;
            line-height: 40px;
            .partition {
              margin: 0 15px;
            }
          }
          .item_tag_container {
            display: flex;
            margin-top: 16px;
            .item_tag {
              overflow: hidden;
              width: 148px;
              height: 52px;
              background: #f5f5f5;
              margin-right: 20px;
              line-height: 52px;
              border-radius: 10px;
              color: #666666;
              font-size: 28px;
              text-align: center;
            }
          }
          .item_btm {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;
            font-size: 24px;
            color: #969b9e;
            line-height: 34px;
            .off_time {
              color: #4ea27c;
            }
          }
        }
        .unpublished_item1 {
          height: 210px;
        }
      }
    }
    .btn_container {
      position: absolute;
      bottom: 0;
      z-index: 999;
      width: 100%;
      height: 96px;
      background: #eee;
      display: flex;
      .el-button--primary {
        width: 100%;
        height: 100%;
        background: #4ea27c;
        border: none;
        font-size: 30px;
        color: #ffffff;
        border-radius: 0;
      }
    }
  }
}

::v-deep .van-tabs__nav {
  background: transparent;
  display: block;
  .van-tab {
    float: left;
    width: 160px;
    font-size: 32px;
    line-height: 66px;
    color: #969b9e;
  }
  .van-tab--active {
    font-weight: 800;
    color: #282b32;
  }
  .van-tabs__line {
    width: 48px;
    height: 8px;
    background: #4ea27c;
  }
}
::v-deep .van-checkbox__icon {
  width: 28px;
  height: 28px;
  .van-icon {
    width: 100%;
    height: 100%;
    &::before {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }
  }
}
::v-deep .van-checkbox__label {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
</style>
